<script lang="ts">
  import {
    PUBLIC_SITE_NAME,
    PUBLIC_SITE_DESCRIPTION,
    PUBLIC_SITE_URL,
    PUBLIC_SITE_IMAGE,
    PUBLIC_IMAGE_BASE_URL,
    PUBLIC_TWITTER_HANDLE,
    PUBLIC_TWITTER_SITE,
    PUBLIC_TWITTER_CARD_TYPE
  } from '$env/static/public';
  import { page } from '$app/stores';

  export let title = '';
  export let description = PUBLIC_SITE_DESCRIPTION;
  export let keywords = '';
  export let images = [];
  export let imageAlt: string | undefined;
  export let ogImage: string | undefined; // <-- NEW
  export let og = true;
  export let ogType = 'article'; // default for tutorials
  export let twitter = true;
  export let crawl = true;

  let titleTemplate = `%s | ${PUBLIC_SITE_NAME}`;

  if (!title) {
    title = PUBLIC_SITE_NAME;
    titleTemplate = '%s';
  }

  // Determine OG/Twitter image
  let imageUrl = '';
  imageAlt = imageAlt || title;

  if (ogImage) {
    imageUrl = ogImage.startsWith('http')
      ? ogImage
      : `${PUBLIC_IMAGE_BASE_URL.replace(/\/$/, '')}/${ogImage.replace(/^\//, '')}`;
  } else if (images.length > 0) {
    const image = images[0];
    imageUrl = image.url.startsWith('http')
      ? image.url
      : `${PUBLIC_IMAGE_BASE_URL}${image.url}`;
    imageAlt = image.alt || imageAlt;
  } else {
    imageUrl = PUBLIC_SITE_IMAGE;
    imageAlt = imageAlt || PUBLIC_SITE_NAME;
  }

  const ogData = og
    ? {
        url: PUBLIC_SITE_URL.replace(/\/$/, '') + $page.url.pathname,
        title,
        description,
        imageUrl,
        imageAlt,
        siteName: PUBLIC_SITE_NAME
      }
    : undefined;

  const twitterData = twitter
    ? {
        handle: PUBLIC_TWITTER_HANDLE || '',
        site: PUBLIC_TWITTER_SITE || '',
        cardType: PUBLIC_TWITTER_CARD_TYPE || 'summary_large_image',
        title,
        description,
        image: imageUrl,
        imageAlt: imageAlt
      }
    : undefined;
</script>

<svelte:head>
  <title>{title}</title>
  <meta name="description" content={description} />
  <meta name="keywords" content={keywords} />
  <link rel="canonical" href={PUBLIC_SITE_URL + $page.url.pathname} />

  <!-- Robots -->
  {#if crawl === false}
    <meta name="robots" content="noindex, nofollow" />
  {:else}
    <meta name="robots" content="index, follow" />
  {/if}
  <!-- Open Graph -->
  {#if ogType}
    <meta property="og:type" content={ogType} />
  {:else}
    <meta property="og:type" content="website" />
  {/if}
  <meta property="og:locale" content="en_US" />
  <meta property="og:locale:alternate" content="en_GB" />

  {#if ogData}
    <meta property="og:url" content={ogData.url} />
    <meta property="og:title" content={ogData.title} />
    <meta property="og:description" content={ogData.description} />
    <meta property="og:site_name" content={ogData.siteName} />
    <meta property="og:image" content={ogData.imageUrl} />
    <meta property="og:image:alt" content={ogData.imageAlt} />
  {/if}

  <!-- Twitter -->
  {#if twitterData}
    <meta name="twitter:card" content={twitterData.cardType} />
    <meta name="twitter:site" content={twitterData.site} />
    <meta name="twitter:creator" content={twitterData.handle} />
    <meta name="twitter:title" content={twitterData.title} />
    <meta name="twitter:description" content={twitterData.description} />
    <meta name="twitter:image" content={twitterData.image} />
    <meta name="twitter:image:alt" content={twitterData.imageAlt} />
  {/if}
</svelte:head>
